import { Injectable } from '@angular/core';
import { Params } from '@angular/router';
import { Observable, Subject, filter } from 'rxjs';
/**
 * https://medium.com/@Armandotrue/broadcasting-events-in-angular-b85289a4d685
 *
 * Example use case:
 * - look at file event-example.component.ts
 */

export enum AppEventType {
  ClickedOnSearch = 'CLICKED_ON_SEARCH',
  ClickedOpenDateSelect = 'CLICKED_OPEN_DATE_SELECT',
  ClickedToggleAssociationDrawer = 'CLICKED_TOGGLE_ASSOCIATION_DRAWER',
  ClickedPageFocusMode = 'CLICKED_PAGE_FOCUS_MODE',
}

/** What each event carries; `on()` hands its subscribers this type. */
export interface AppEventPayloads {
  [AppEventType.ClickedOnSearch]: { queryParams: Params };
  [AppEventType.ClickedOpenDateSelect]: null;
  [AppEventType.ClickedToggleAssociationDrawer]: null;
  [AppEventType.ClickedPageFocusMode]: { isFocusModeEnabled: boolean };
}

@Injectable({ providedIn: 'root' })
export class EventQueueService {
  private eventBroker = new Subject<AppEvent<AppEventType>>();

  on<K extends AppEventType>(eventType: K): Observable<AppEvent<K>> {
    return this.eventBroker.pipe(filter((event): event is AppEvent<K> => event.type === eventType));
  }

  dispatch(event: AppEvent<AppEventType>): void {
    this.eventBroker.next(event);
  }
}

export class AppEvent<K extends AppEventType> {
  constructor(
    public type: K,
    public payload: AppEventPayloads[K],
  ) {}
}

// export class SomeOtherEvent extends AppEvent {
//   constructor(payload: number) {
//     super(AppEventType.SomeOtherEvent, payload);
//   }
// }
